const doc = [({"en":({"js":({"admin":({"economy":({"account_dimensions":({"account_dimensions":"Account dimensions for %{name}"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;